<template>
  <div class="introduction texture-bg-css">
    <Top></Top>
    <Storehouse></Storehouse>
  </div>
</template>

<script>
import Top from '@/components/introduction/Top'
import Storehouse from '@/components/introduction/Storehouse'

export default {
  name: 'Introduction',
  components: {
    Top,
    Storehouse
  },
  mixins: [],
  data() {
    return {}
  },
  mounted: function() {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
